import $ from 'jquery'
import { createDiv } from './utils/domUtils'
import { getReactScriptsLoader } from './utils/loadScript'

const DEFAULT_ENQUIRY_FORM_ID = 1

const initScripts = getReactScriptsLoader(['/dist/RequestQuote.js'], () => {
  if (!window.RequestQuote) throw new Error('RequestQuote not found')
})

export function initialise() {
  $('a[href="#form"]').on('click', function (e) {
    const $elem = $(this)
    e.preventDefault()
    initScripts()
      .then(() => {
        const [div, id] = createDiv()
        window.RequestQuote.init(id, {
          form_id: $elem.data('form-id') || DEFAULT_ENQUIRY_FORM_ID,
          defaultValue: {
            referrer: window.location.href,
            category_id: $elem.data('category-id'),
            product_id: $elem.data('product-id'),
          },
        })
      })
      .catch(() => {})
  })
  $('a[href*="#form-"]').on('click', function (e) {
    e.preventDefault()
    const $elem = $(this)
    const form_id = $elem.attr('href').split('#form-')[1]
    if (isNaN(parseInt(form_id))) return
    initScripts()
      .then(() => {
        const [div, id] = createDiv()
        window.RequestQuote.init(id, {
          form_id,
          defaultValue: {
            referrer: window.location.href,
            category_id: $elem.data('category-id'),
            product_id: $elem.data('product-id'),
          },
        })
      })
      .catch((err) => {})
  })
}
